(function (Drupal, $, once) {
  Drupal.behaviors.footnote = {
    attach: function (context) {
      $(() => {

        // tablenotes
        once('table-wrap', $('table')).forEach(element => {
          if (!$(element).parent().hasClass('table-wrap')) {
            $(element).wrap("<div class='table-wrap'></div>");
          }
        });

        once('table-wrap', $('.table-wrap')).forEach(element => {
          let $table = $(element);

          if ($table.find('.see-footnote__wrapper').length) {
            if (!$table.next('.tablenotes').length) {
              $('<ul class="tablenotes"></ul>').insertAfter($table);
            }
            let usedTargets = [];
            $table.find('.see-footnote__wrapper.tablenote').each(function () {
              let target = $(this).find('.see-footnote__link').attr('href');

              if (!usedTargets.includes(target)) {
                $table.next('.tablenotes').append($("li" +target));
                usedTargets.push(target);
              }
            });
          }
        });
        // $('.more-details__wrapper.tablenotes__wrapper').remove();

        // footnote direction
        once('footnote-direction', $('.footnote__citations-wrapper')).forEach(element => {
          const footnote = $(element);
          const container = $('.layout-content');
          const isArabic = $('.main[lang="ar"]').length > 0;
          const offset = isArabic
            ? (footnote.offset().left + footnote.outerWidth()) - (container.offset().left + container.outerWidth())
            : ($(window).width() - (footnote.offset().left + footnote.outerWidth())) - ($(window).width() - (container.offset().left + container.outerWidth()));

          if (offset < 280) {
            footnote.addClass('flipped');
          }
        });

        // footnote mobile
        once('footnote-mobile', $('.footnote__citations-wrapper a.see-footnote__link')).forEach(element => {
          $(element).on('click touchstart', function (e) {
            if ($(window).width() < 1024) {
              e.preventDefault();
              $(this).closest('.footnote__citations-wrapper').addClass('is-open');
            }
          });
        });

        once('footnote-mobile-close', $('.footnote__citations-wrapper .footnote-mobile-close')).forEach(element => {
          $(element).on('click touchstart', function (e) {
            if ($(window).width() < 1024) {
              $(this).closest('.footnote__citations-wrapper').removeClass('is-open');
            }
          });
        });

        // footnote mobile scroll hidden
        $(document).on('click touchstart', '.more-details__wrapper a.footnote-label', function (e) {
          if ($(window).width() < 1024) {
            e.preventDefault();
            $(window).scrollTop(
              $($(this).attr("href")).offset().top -
              $(".layout-sidebar").height() - 10
            );
          }
        });

        $(document).on('mouseup touchend', function (e) {
          const container = $(".footnote__citations-wrapper.is-open");
          if (!container.is(e.target) && container.find(e.target).length === 0) {
            container.removeClass('is-open');
          }
        });
      });
    }
  }
})(Drupal, jQuery, once);
